/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {LogFormComponent as ɵc} from './log-form/log-form.component';
export {LogComponent as ɵb} from './log.component';
export {declaration as ɵa} from './log.module';
export {LogRoutes as ɵd} from './log.routing';